import { mergeWith, isEmpty } from 'lodash';

export default (...args) =>
    mergeWith(...args, (objValue, srcValue) => {
        if (isEmpty(srcValue)) {
            return objValue;
        }
        return srcValue;
    });
